module.exports = __webpack_public_path__ + "static/media/SUSHI.30c82158.png";